/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect} from 'react'
import {useMutation, useQueryClient} from 'react-query'
import {MenuComponent} from '../../../../../../../_metronic/assets/ts/components'
import {ID, KTSVG, QUERIES} from '../../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {useQueryResponse} from '../../core/QueryResponseProvider'
import {Chat} from '../../core/_models'

type Props = {
  id: ID
  status: boolean
  chat: Chat
}

const ChatActionCell: FC<Props> = ({id, status, chat}) => {
  const chatListContext = useListView()

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const onStatusShow = (action: boolean) => {
    chatListContext.setChat(chat)
    chatListContext.setStatusModal(true, false)
  }

  const setChatValues = () => {
    chatListContext.setItemIdForUpdate(id)
    chatListContext.setChat(chat)
  }

  return (
    <>
      <a
        href='#'
        onClick={() => setChatValues()}
        className='btn btn-light btn-active-light-primary btn-sm me-5'
        data-kt-menu-placement='bottom-end'
      >
        View Chat
      </a>
      <a
        onClick={() => onStatusShow(true)}
        title='Delete Chat'
        className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm'
      >
        <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-3' />
      </a>
    </>
  )
}

export {ChatActionCell}
